// extracted by mini-css-extract-plugin
export default {"attributeTable":"WmlL","disabled":"_3c9w"};